export const modalPopLink = {
    bind(el, binding, vnode) {
        const self = vnode?.context;
        if (!self.$context.is.modal) return;
        [...el.querySelectorAll('a')].forEach(x => {
            var icon = document.createElement('i');
            icon.classList.add('zm-icon-window-new');
            x.appendChild(icon)
        });
    }
};

const interceptLinkEventMap = new WeakMap();

export const interceptLink = {
  inserted(el, binding) {
    bindClickEvent(el, binding);
  },
  update(el, binding) {
    bindClickEvent(el, binding);
  },
  unbind(el) {
    removeClickEvent(el);
  },
};

function bindClickEvent(el, binding) {
  removeClickEvent(el);
  [...el.querySelectorAll('a')].forEach((link) => {
    const handler = (event) => handleLinkClick(event, binding);
    interceptLinkEventMap.set(link, handler);
    link.addEventListener('click', handler);
  });
}

function removeClickEvent(el) {
  [...el.querySelectorAll('a')].forEach((link) => {
    const handler = interceptLinkEventMap.get(link);
    if (handler) {
      link.removeEventListener('click', handler);
      interceptLinkEventMap.delete(link);
    }
  });
}

function handleLinkClick(event, binding) {
  event.preventDefault();

  if (binding.value) {
    binding.value(event);
  } else {
    window.location.href = event?.target?.href;
  }
}
